import { type ReactElement } from 'react';
import { TdsTag } from '@scania/tegel-react';
import { type VehicleRowItem } from '..';
import styles from '../style.module.scss';

export const renderVehicleTypeCell = ({ vehicle }: VehicleRowItem): ReactElement => (
  <div className={styles['vehicle-type']}>
    <span>{vehicle.vehicleType}</span>
    <TdsTag size="sm" text={vehicle.propulsion ?? 'BEV'} variant="Neutral" />
  </div>
);
